<template>
  <div class="images-container">
    <div v-for="image in images" :key="image.url" class="image">
      <router-link
        class="undecorated-router-link"
        :is="image.profile ? 'router-link' : 'span'"
        :to="{
          name: 'student-community-profile-view',
          params: { id: image.profile },
        }"
        target="_blank"
      >
        <HMImageIcon
          :image="image"
          :size="size"
          :title="image.title"
          v-tooltip="{
            content: image.tooltip,
            delay: 100,
            placement: 'top',
            container: 'body',
          }"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HMImagesWithLinkStack',
  props: {
    images: {
      type: Array,
      required: true,
    },
    size: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.image {
  display: inline-block;
  position: relative;
  border-radius: 50%;
  background-size: cover;
  background-position: center center;
  background-color: white;
  margin-right: -15px;
  vertical-align: middle;
  &:last-child {
    margin-right: 0;
  }
}

.images-container {
  white-space: nowrap;
}
</style>
